import api from './utils/api';

class PhonesService {
  async sendPhone(phone) {
    const result = await api.post('/send-phone', { phone });

    return result.data;
  }

  async verifPhone(phone, code) {
    const result = await api.post('/verif-phone', { phone, code });

    return result.data;
  }
}

export default new PhonesService();
